import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface Message {
  id: string
  role: 'user' | 'assistant'
  content: string
  timestamp: string
}

interface ChatState {
  isOpen: boolean
  messages: Message[]
  conversationId: string
  input: string
  loading: boolean
  streamingContent: string
  
  // Actions
  setOpen: (open: boolean) => void
  toggleOpen: () => void
  setMessages: (messages: Message[]) => void
  addMessage: (message: Message) => void
  clearMessages: () => void
  setConversationId: (id: string) => void
  setInput: (input: string) => void
  setLoading: (loading: boolean) => void
  setStreamingContent: (content: string) => void
  appendStreamingContent: (content: string) => void
}

export const useChatStore = create<ChatState>()(
  persist(
    (set, _get) => ({
      isOpen: false,
      messages: [],
      conversationId: '',
      input: '',
      loading: false,
      streamingContent: '',

      setOpen: (open) => set({ isOpen: open }),
      toggleOpen: () => set((state) => ({ isOpen: !state.isOpen })),
      setMessages: (messages) => set({ messages }),
      addMessage: (message) => set((state) => ({ 
        messages: [...state.messages, message] 
      })),
      clearMessages: () => set({ 
        messages: [], 
        conversationId: '', 
        streamingContent: '' 
      }),
      setConversationId: (id) => set({ conversationId: id }),
      setInput: (input) => set({ input }),
      setLoading: (loading) => set({ loading }),
      setStreamingContent: (content) => set({ streamingContent: content }),
      appendStreamingContent: (content) => set((state) => ({ 
        streamingContent: state.streamingContent + content 
      })),
    }),
    {
      name: 'kirjuri-chat-storage',
      // Only persist messages and conversationId, not UI state
      partialize: (state) => ({ 
        messages: state.messages, 
        conversationId: state.conversationId 
      }),
    }
  )
)
